import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function MediaBanner() {

  const [NewsBanner, setNewsBanner] = useState({});

  useEffect(() => {
    const fetchNewsBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/news/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setNewsBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchNewsBanner();
  }, []);

  return (
    <div className='common-banner-sec common-flex-center media-news-banner'
      style={{
        backgroundImage: `url(${apiUrl.apiUrl + `/` + NewsBanner.banner_image
          })`,
      }}
    >
      <div className='overlay'></div>
      <Container fluid>
        <Row className='common-flex-center'>
          <Col md={8}>
            <div className=' '>
              <h1 className='common-head whiteColor'>{NewsBanner.banner_title}</h1>
              {/* <p className='common-para whiteColor'>{NewsBanner.banner_description}</p> */}
            </div>
          </Col>
        </Row>
      </Container>
    </div>

  );
}

export default MediaBanner;